import { mapActions } from 'vuex'

import chat from './chat.vue'
import activityStream from './activityStream.vue'

export default {
  name: 'Footer',
  components: {
    chat,
    activityStream
  },
  methods: {
    ...mapActions({
      toggleFooterBlock: 'TOGGLE_FOOTER_BLOCK',
      connectToWebsocket: 'CONNECT_TO_WS'
    })
  },
  computed: {
    footerBlockHidden () {
      return this.$store.state.appSettings.footerBlockHidden
    }
  },
  created () {
    this.connectToWebsocket()
  }
}
